// Hook do edycji encji DevStudio

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPutEntityRequest {
  entityUuid: string;
  name: string;
  symbol: string;
  tableName: string;
}

const putEntity = ({ entityUuid, name, symbol, tableName }: IPutEntityRequest): Promise<void> =>
  axios.put(`/panel/dev-studio/entities/${entityUuid}`, { name, symbol, tableName });

export const usePutEntity = (
  options?: UseMutationOptions<void, IError, IPutEntityRequest>
) => useMutation<void, IError, IPutEntityRequest>(putEntity, options);
